import { GetterTree } from 'vuex'
import orderBy from 'lodash/orderBy'

import type { SharedFoldersState } from './sharedFolder.types'
import { PopulatedProductTechpack } from 'vue-common/src/generated'

export const getters: GetterTree<SharedFoldersState, unknown> = {
  sharedFolder(state) {
    return { ...state.sharedFolder, techpacks: orderBy(state.sharedFolder?.techpacks, 'created_at', 'desc') }
  },
  isFetching: state => state.isFetching,
  isCreating: state => {
    return state.isCreating
  },
  sharedFolders: state => {
    return state.sharedFolders
  },
  hasTechpacks: state => {
    return state.sharedFolder?.techpacks?.length
  },
  sharedFolderHasPublicLink(state, tpId) {
    const findTP = state.sharedFolder?.techpacks?.find(
      shareTechpack => (shareTechpack.techpack as PopulatedProductTechpack)._id === tpId
    )
    return findTP ? true : false
  },
  sharedFolderName(state): string {
    return state.sharedFolder?.name || ''
  },
  sharedFoldersContactsLength(state): number {
    return state.sharedFolder?.contacts?.length || 0
  },
  sharedFolderContactEmails(state): Array<string> {
    const emails =
      state.sharedFolder?.contacts?.map(c => {
        if (typeof c.contact !== 'string') return c.contact.email
        return ''
      }) || []

    return emails.filter(Boolean)
  }
}
